
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import useChatSetting from '@/modules/chat/setting/model/edit';
import { ROUTE_NAME_CHAT } from '@/modules/chat/router';

export default defineComponent({
    name: ROUTE_NAME_CHAT.SETTING,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, fetch, actions } = useChatSetting();

        onMounted(async () => {
            await fetch();
        });

        return { model, v$, actions };
    }
});
